import React from 'react';

import LazyImgixImage from '@components/LazyImgixImage';
import { getImgixSrc } from '@utils/images';

interface ProfileOverviewProps {
  details: string;
  detailsDescription: string;
  image: string;
  name: string;
  projectSlug: string;
  title: string;
}

const ProfileOverview = ({
  details,
  detailsDescription,
  image,
  name,
  projectSlug,
  title,
}: ProfileOverviewProps) => {
  return (
    <div className="grid grid-cols-9 gap-24 py-32 xs:grid-cols-5 xs:pr-16 sm:col-span-6 sm:grid-cols-7 sm:pr-0 md:col-span-5 lg:grid-cols-5">
      <div className="relative col-span-2 h-80 w-80 overflow-hidden rounded-full text-center xs:col-span-1 xs:h-96 xs:w-96">
        <LazyImgixImage
          className="h-80 w-80 xs:h-96 xs:w-96"
          src={getImgixSrc({ path: `projects/${projectSlug}/${image}`, isEnvDependent: false })}
        />
      </div>
      <div className="col-span-7 ml-8 mt-16 flex flex-col xs:col-span-4 sm:col-span-7 sm:col-start-3 md:mt-0 lg:col-span-4">
        <h3 className="my-0 font-suisse-screen text-disclosure-lg text-primary-black xs:text-headline-alt-sm sm:pr-6">
          {name}
        </h3>
        <div className="pb-12 font-suisse-screen text-disclosure-sm text-grayscale-charcoal xs:text-disclosure-md sm:pr-6">
          {title}
        </div>
        <div className="h-px border-0 border-b border-solid border-grayscale-beige"></div>
        <div className="mt-12 font-suisse-intl text-icon-lg text-primary-black sm:pr-6">
          <span className="font-[500]">{detailsDescription}:</span> {details}
        </div>
      </div>
    </div>
  );
};

export default ProfileOverview;
